<template>
  <v-list dense class="pt-0 mb-3">
    <v-subheader>File trasferiti<v-icon small class="ml-3" @click="onRefresh">mdi-refresh</v-icon></v-subheader>
    <v-list-item v-for="(file, i) in files" :key="i">
      <v-list-item-title class="text-caption">{{file}}</v-list-item-title>
      <v-list-item-icon>
        <v-icon small title="Cancella il file" @click="removeFile(file)">mdi-delete-outline</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </v-list> 
</template>

<script>
export default {
  props: {
    files: Array
  },
  data() {
    return {

    }
  },
  methods: {
    onRefresh() {
      this.$emit('refresh')
    },
    removeFile(item) {
      this.$emit('delete', item)
    }
  }
}
</script>
